import React from 'react'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'
import { BsFillPersonLinesFill } from 'react-icons/bs'


function SocialLinksMob() {

    const links = [
        {
            id: 1,
            child:
                <>
                    LinkedIn <FaLinkedin size={30} />
                </>
            ,
            href: 'https://www.linkedin.com/in/shubham-kumar-85ab42202/',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                    GitHub <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/shubham7546',
        },
        {
            id: 3,
            child: (
                <>
                    Mail <HiOutlineMail size={30} />
                </>
            ),
            href: 'mailto:shubhamkumar.dn@gmail.com',
        },
        {
            id: 4,
            child: (
                <>
                    Resume <BsFillPersonLinesFill size={30} />
                </>
            ),
            href: 'https://resume.io/r/COWKVeDBb',
            style: 'rounded-br-md',
            download: true,
        },
    ];


    return (

        <div className=' lg:flex flex-col top-[35%] left-0 fixed'>
            <ul>
                {links.map(({ id, child, href, style, download }) => (
                    <li

                        key={id}
                        className={`flex items-center justify-between w-40 px-4 h-14 ml-[-100px] bg-gray-500 hover:bg-slate-950 hover:rounded-md duration-300 ${style}`}>
                        <a
                            href={href}
                            className='flex items-center justify-between w-full text-white'
                            download={download}
                            target='_blank'
                            rel='noreferrer'>
                            {child}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default SocialLinksMob